import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

import { queryClient } from '../../configs/queryClient';
import useServiceHistoryQuery from '../useServiceHistoryQuery';

async function update(axios: AxiosInstance, serviceHistoryRequestId: number, dataForEndpoint: any): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/service-history-request/${serviceHistoryRequestId}`, dataForEndpoint);
  return data;
}

export default function useUpdateServiceHistoryRequestStatusMutation(serviceHistoryRequestId: number) {
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: (dataForEndpoint: any) => update(axios, serviceHistoryRequestId, dataForEndpoint),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: useServiceHistoryQuery.getKey(serviceHistoryRequestId) });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response);
    },
  });
}
